<template>
  <div>
    <div class="font-weight-bold color-gray-7 mt-2 mb-3">
      Informaci&oacute;n de Localidad de Asistencia Tecnológica:
    </div>
    <validation-provider
      ref="caatLocation"
      :rules="profileData.caatLocations.length > 0 ? '' : 'required'"
      v-slot="{ errors: locationErrors }"
    >
      <div class="row">
        <div v-if="!readonly" class="col-md-4 col-sm-12">
          <validation-observer ref="locationEntryCAAT" disabled>
            <div class="form-group">
              <label class="field-label">CAAT:</label>
              <validation-provider rules="required" v-slot="{ errors }">
                <custom-drop-down
                  ref="centersDdl"
                  :options="serviceCenterOptionsAvailable"
                  fieldname="name"
                  fieldkey="id"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  custom-error-msg="Favor seleccione."
                  v-model="selectedServiceCenter"
                ></custom-drop-down>
              </validation-provider>
            </div>
          </validation-observer>
          <action-button
            variant="success float-right"
            text="Añadir"
            i="fas fa-file-medical"
            @click="addingLocation"
          />
        </div>
        <div
          class="col-sm-12 mt-2 mt-md-0"
          :class="{ 'col-md-8 chips-col': !readonly }"
        >
          <label v-if="!readonly" class="field-label">
            CAAT Seleccionados:
          </label>
          <div class="chips-container">
            <div
              class="chip"
              v-for="(chipData, index) in selectedCaats"
              :key="index"
            >
              <template
                v-for="(config, idx) in [
                  { labelText: 'CAAT:', valueProp: 'caatName' },
                ]"
              >
                <span :key="idx">
                  <span class="chip-label" v-if="config.labelText">
                    {{ config.labelText }}
                  </span>
                  <span class="chip-field font-weight-bold">
                    {{ chipData[config.valueProp] }}
                  </span>
                </span>
              </template>
              <a @click.prevent="removeChip(index)">
                <em class="far fa-lg fa-times-circle chip-close-icon" />
              </a>
            </div>
            <error
              v-if="locationErrors.length > 0"
              variant="no-border"
              :message="locationErrors[0]"
            />
          </div>
        </div>
      </div>
    </validation-provider>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import applicationIds from '@/utils/constants/applicationIds';
import accessLevel from '@/utils/constants/accessLevel';
import eduespService from '@/services/eduesp';
import ActionButton from '@/components/common/ActionButton';
import Error from '@/components/common/Error';

export default {
  name: 'CAATProfile',
  components: {
    CustomDropDown,
    ActionButton,
    Error,
  },
  model: {
    prop: 'profile',
    event: 'selectionChanged',
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    profile: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      serviceCenterOptions: [],
      options: [],
      selectedServiceCenter: null,
      chipsConfig: [],
      selectedItems: [],
    };
  },
  computed: {
    profileData: {
      get() {
        return this.profile || {};
      },
      set(val) {
        this.$emit('profile-change', val);
      },
    },
    inEditMode() {
      return !!this.profileData.userId;
    },
    accessLevel() {
      return accessLevel;
    },
    appId() {
      let applicationId = applicationIds.mipe;

      if (this.isFinanceUser) {
        applicationId = applicationIds.financePortal;
      }

      if (this.isRpUser) {
        applicationId = applicationIds.remProPortal;
      }

      return applicationId;
    },
    checkAccessLevel() {
      return (userAccessLevel) => this.mipeRole?.accessLevel == userAccessLevel;
    },
    mipeRole() {
      return this.user.roles.find(
        (r) => r.applicationId.toUpperCase() == this.appId
      );
    },
    serviceCenterOptionsAvailable() {
      return this.serviceCenterOptions.filter((x) => {
        return !this.addedCaatIds.includes(x.id);
      });
    },
    addedCaatIds() {
      return this.selectedItems.map((x) => x.caatId) ?? [];
    },
    selectedCaats() {
      const items = this.selectedItems || this.profileData.caatLocations;
      return items;
    },
  },
  async mounted() {
    await this.getListOfCaat();
    setTimeout(() => {
      if (this.profileData.caatLocations) {
        this.selectedItems = this.profileData.caatLocations;
      }
    }, 1000);
  },
  methods: {
    async addingLocation() {
      const passed = await this.validate();
      if (passed) {
        let result = { userId: this.user.userId };
        result.caatId = this.selectedServiceCenter.id;
        result.caatName = this.selectedServiceCenter.name;
        this.selectedServiceCenter = null;
        const newLocation = result;
        this.$refs.locationEntryCAAT.reset();
        this.selectedItems.push(newLocation);
        this.profileData.caatLocations = this.selectedItems;
        this.$emit('selectionChanged', this.profileData);
      }
    },
    async save() {
      if (this.inEditMode) {
        const data = this.profileData;
        data.activeFlag = this.user.activeFlag ? '1' : '0';
        data.firstName = this.user.firstName;
        data.middleName = this.user.middleInitial;
        data.lastMaternalName = this.user.maternalLastName;
        data.lastPaternalName = this.user.paternalLastName;
        return eduespService.updateUserProfile(data);
      } else {
        this.profileData.userId = this.user.userId;
        return eduespService.createUserProfile(this.profileData);
      }
    },
    async validate() {
      return await this.$refs.locationEntryCAAT.validate();
    },
    selectionChangeValMode: () => {
      return {
        on: ['selectionChanged'],
      };
    },
    async getListOfCaat() {
      const res = await eduespService.getCaat();
      this.serviceCenterOptions = res;
    },
    removeChip(index) {
      let itemToRemove = this.selectedItems[index];

      let indexToRemove = this.selectedItems.indexOf(itemToRemove);

      let deleted = this.selectedItems.splice(indexToRemove, 1);
      this.$emit('selectionChanged', this.selectedItems);
      this.$emit('removingItem', deleted[0]);
    },
  },
};
</script>

<style lang="scss" scoped>
.chip {
  border: 1px solid #b7c4bd;
  border-radius: 16px;
  display: inline-block;
  padding: 2px 4px 2px 14px;
  margin: 0 0.5rem 0.5rem 0.5rem;
}

.chip-label {
  font: 1rem 'Lato';
  letter-spacing: 0;
  color: #727272;
  font-weight: normal;
}

.chip-field {
  margin-right: 1rem;
  margin-left: 0.25rem;
}

.chip-close-icon {
  color: red;
  vertical-align: -2px;
}

.chips-col {
  border-left: 1px solid #e2e2e2;
}

@media only screen and (max-width: 768px) {
  .chips-col {
    border-left: unset;
  }
}
</style>
